import { ENVIRONMENT_QUAL } from './qual';

export const environment = {
  ...ENVIRONMENT_QUAL,
  apiServer: 'https://arcadia.app.1life.com',
  myoneServer: 'https://arcadia.app.1life.com',
  sentry: {
    enabled: true,
    dsn: 'https://94fb2cb964527591835f763ad4493a4f@o4506221115408384.ingest.us.sentry.io/4506855554154496',
    environment: 'onelife-arcadia',
  },
  launchDarklyClientId: '604ffcb3a544ec0cd24ff0bc',
};
